import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { WatchlistProvider } from './hooks/useWatchlist';
import { TickerPricesProvider } from './hooks/useTickerPrices';
import MarketingPage from './pages/MarketingPage';
import PlatformPage from './pages/PlatformPage';
import BillingPage from './pages/BillingPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <TickerPricesProvider>
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      <Route
        path="/platform"
        element={
          <ProtectedRoute>
            <WatchlistProvider>
              <PlatformPage />
            </WatchlistProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <ProtectedRoute>
            <BillingPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </TickerPricesProvider>
  );
}